import { Injectable } from '@angular/core';
import { switchTap } from '@lycoris-nubila/ngx-lycoris';
import { isEmpty } from 'lodash-es';
import { Observable, of } from 'rxjs';
import { map, pluck, shareReplay, switchMap } from 'rxjs/operators';

import { ModuleApplicationPort } from 'module/port/module-application.port';
import { CoacheeProfileController } from 'presentation/page/profile/coachee-profile/coachee-profile.controller';
import { TaskApplicationPort } from 'task/port/task-application.port';
import { ITask } from 'task/task';

@Injectable()
export class CoacheeProfileInformationActivitiesController {
	public pendingTasks$: Observable<ITask[]>;
	public coacheeId$: Observable<string>;

	constructor(
		private _taskApplicationPort: TaskApplicationPort,
		private _moduleApplicationPort: ModuleApplicationPort,
		private _coacheeProfileController: CoacheeProfileController
	) {
		this._initObservables();
	}

	private _initObservables() {
		this.coacheeId$ = this._coacheeProfileController.coachee$.pipe(
			map((coachee) => coachee?.id),
			shareReplay({ bufferSize: 1, refCount: true })
		);

		this.pendingTasks$ = this._coacheeProfileController.coachee$.pipe(
			pluck('id'),
			switchMap((coacheeId) =>
				this._taskApplicationPort.observeUserPendingTasks(coacheeId)
			),
			map((data) => data?.data),
			switchTap((tasks) => {
				const modulesId = tasks
					.filter((t) => !!t.modulesId)
					.map((t) => t.modulesId)
					.reduce((p, c) => [...p, ...c], []);
				return isEmpty(modulesId)
					? of([])
					: this._moduleApplicationPort.observeUserModulesByIds({ ids: modulesId });
			}),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}
}
